import { Sel, STagNew } from '#~/stag/index.js';
import { Icon } from '@studio/design-system/icon';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { TriggerProps } from '../../types.js';

/** Iris vendor `<Trigger>` component with compact chevron-only UI. */
export const TriggerIris = ({
  className,
  orgOnly,
  hasRegistryLoaded: _hasRegistryLoaded,
  isRegistryLoading: _isRegistryLoading,
  selectedOrgId,
  selectedRoomId,
  ...props
}: TriggerProps): ReactElement => (
  <div
    className={twMerge(
      'flex !h-18 !w-18 items-center justify-center gap-8 rounded-4 bg-base-300 text-muted transition-colors hover:text-foreground group-x-open:text-foreground',
      className
    )}
    {...STagNew(Sel.SettingsSwitcher, 'trigger', orgOnly ? 'organization' : 'studio')}
    {...props}
  >
    <div>
      <Icon className='m-auto text-[6px] transition-transform' icon='chevron-up-filled' />
    </div>
  </div>
);
